export { default } from "./LogoutButton";


// WEBPACK FOOTER //
// ./src/components/LogoutButton/index.js